import src from "IMAGE";
export default { src, width: 1374, height: 500, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAIAAAAhqtkfAAAAMklEQVR42jXJWwoAIAhEUREUfMDU/jdbOHU/7xFVdfeq6u7MBLAmIdxF29MDM4sIGn4HbBUDEB6rf9EAAAAASUVORK5CYII="};
